var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.isRequestLogOpen && "d-flex" },
    [
      _c("custom-simple-table", {
        attrs: {
          item: _vm.details,
          "i18-path": "requests.fields",
          "table-keys": _vm.tableKeys,
          "specific-classes": _vm.active.work_order_group_type_nat
            ? []
            : _vm.cssClasses,
          "attributes-obj-ref": _vm.attributesObjRef
        }
      }),
      _vm._v(" "),
      _c("div", { class: _vm.isRequestLogOpen && "mx-2" }, [
        _c("span", { staticClass: "caption font-weight-bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.generateMessage("requests.fields." + "customer_comment")
              ) +
              " :\n    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "caption" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.formatField(_vm.active, "customer_comment")) +
              "\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }